<template>
  <div id="ClaimsOrdersSearch" class="p-0 left-menu">
    <b-col id="claimsOrdersSearchHeader" class="nav-sub form-horizontal control-group p-0">
      <h4>{{ getContentItem("search") }}</h4>
      <b-col id="claimsOrdersSearchBody" class="claimsOrdersSearchBody">
        <form @submit.prevent="search">
          <label>{{ searchByNumberLabel || getContentItem("searchByMessage") }}</label>
          <b-form-input
            id="claimsOrdersSearchNumberInput"
            v-model="claimsOrdersSearchNumber"
            class="mb-3"
            size="sm"
          />
          <label>{{ getContentItem("searchByPart") }}</label>
          <b-form-input
            id="claimsOrdersSearchPartInput"
            v-model="claimsOrdersSearchPart"
            class="mb-3"
            size="sm"
          />
          <AvailableDealerCodeSelector
            :show-all-branches-option="false"
            class="mb-1 vSelectDropDownText claimsDealerCodeSearch-largeDropDown claimsDealerCodeSearch-noWrap"
            @selectDealerCode="SetUserDealerCode"
          />
          <div class="text-right">
            <input type="submit" class="btn btn-inverse mt-2" :value="getContentItem('goButton')">
          </div>
        </form>
      </b-col>
    </b-col>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import AvailableDealerCodeSelector from "@/components/Dropdowns/AvailableDealerCodeSelector"

  export default {
    components: {
      AvailableDealerCodeSelector,
    },
    props: {
      searchByNumberLabel: {
        type: String,
        default: ""
      },
    },
    data: () => ({
      claimsOrdersSearchNumber: "",
      claimsOrdersSearchPart: "",
      claimsOrdersSearchAccountCode: "",
    }),
    computed: {
      ...mapGetters(["getContentItem", "activeAccountId"])
    },
    mounted () {
      this.claimsOrdersSearchAccountCode = this.activeAccountId
    },
    methods: {
      SetUserDealerCode(selectedAvailableDealerCode){
        if (selectedAvailableDealerCode.AccountId) {
          this.claimsOrdersSearchAccountCode = selectedAvailableDealerCode.AccountId
        }
      },
      search () {
        this.$router.push({
          name: "Search",
          query: {
            referenceNumber: this.claimsOrdersSearchNumber,
            partNumber: this.claimsOrdersSearchPart,
            accountId: this.claimsOrdersSearchAccountCode.toString()
          }
        }).catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          } 
        });
      }
    },
  }
</script>
